import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=35df69fc&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=35df69fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35df69fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35df69fc')) {
      api.createRecord('35df69fc', component.options)
    } else {
      api.reload('35df69fc', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=35df69fc&scoped=true&", function () {
      api.rerender('35df69fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YrbaQGYvq7Qq/JS/comp/SearchFilterTokens.vue"
export default component.exports